/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { GetDetailsOfDefectResponse } from '../models/get-details-of-defect-response';
import { CreateDetailsOfDefectRequest } from '../models/create-details-of-defect-request';
import { UpdateDetailsOfDefectRequest } from '../models/update-details-of-defect-request';
@Injectable({
  providedIn: 'root',
})
class DetailsOfDefectService extends __BaseService {
  static readonly DetailsOfDefectGetAllPath = '/DetailsOfDefect/GetAll';
  static readonly DetailsOfDefectGetByIdPath = '/DetailsOfDefect/GetById';
  static readonly DetailsOfDefectCreatePath = '/DetailsOfDefect/Create';
  static readonly DetailsOfDefectCreateRangePath = '/DetailsOfDefect/CreateRange';
  static readonly DetailsOfDefectUpdatePath = '/DetailsOfDefect/Update';
  static readonly DetailsOfDefectDeletePath = '/DetailsOfDefect/Delete';
  static readonly DetailsOfDefectDeleteRangePath = '/DetailsOfDefect/DeleteRange';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }
  DetailsOfDefectGetAllResponse(): __Observable<__StrictHttpResponse<Array<GetDetailsOfDefectResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/DetailsOfDefect/GetAll`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<GetDetailsOfDefectResponse>>;
      })
    );
  }  DetailsOfDefectGetAll(): __Observable<Array<GetDetailsOfDefectResponse>> {
    return this.DetailsOfDefectGetAllResponse().pipe(
      __map(_r => _r.body as Array<GetDetailsOfDefectResponse>)
    );
  }

  /**
   * @param Id undefined
   */
  DetailsOfDefectGetByIdResponse(Id?: string): __Observable<__StrictHttpResponse<GetDetailsOfDefectResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (Id != null) __params = __params.set('Id', Id.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/DetailsOfDefect/GetById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GetDetailsOfDefectResponse>;
      })
    );
  }
  /**
   * @param Id undefined
   */
  DetailsOfDefectGetById(Id?: string): __Observable<GetDetailsOfDefectResponse> {
    return this.DetailsOfDefectGetByIdResponse(Id).pipe(
      __map(_r => _r.body as GetDetailsOfDefectResponse)
    );
  }

  /**
   * @param request undefined
   */
  DetailsOfDefectCreateResponse(request: CreateDetailsOfDefectRequest): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/DetailsOfDefect/Create`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param request undefined
   */
  DetailsOfDefectCreate(request: CreateDetailsOfDefectRequest): __Observable<string> {
    return this.DetailsOfDefectCreateResponse(request).pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * @param request undefined
   */
  DetailsOfDefectCreateRangeResponse(request: Array<CreateDetailsOfDefectRequest>): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/DetailsOfDefect/CreateRange`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param request undefined
   */
  DetailsOfDefectCreateRange(request: Array<CreateDetailsOfDefectRequest>): __Observable<Blob> {
    return this.DetailsOfDefectCreateRangeResponse(request).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param request undefined
   */
  DetailsOfDefectUpdateResponse(request: UpdateDetailsOfDefectRequest): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/DetailsOfDefect/Update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param request undefined
   */
  DetailsOfDefectUpdate(request: UpdateDetailsOfDefectRequest): __Observable<Blob> {
    return this.DetailsOfDefectUpdateResponse(request).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param id undefined
   */
  DetailsOfDefectDeleteResponse(id?: string): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (id != null) __params = __params.set('id', id.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/DetailsOfDefect/Delete`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param id undefined
   */
  DetailsOfDefectDelete(id?: string): __Observable<Blob> {
    return this.DetailsOfDefectDeleteResponse(id).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param ids undefined
   */
  DetailsOfDefectDeleteRangeResponse(ids: Array<string>): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = ids;
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/DetailsOfDefect/DeleteRange`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param ids undefined
   */
  DetailsOfDefectDeleteRange(ids: Array<string>): __Observable<Blob> {
    return this.DetailsOfDefectDeleteRangeResponse(ids).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module DetailsOfDefectService {
}

export { DetailsOfDefectService }
